(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // check if theres an iframe in the article
    const article = document.querySelector('div.article-template');
    // select all iframes
    const iframes = article.querySelectorAll('iframe');
    // loop through all iframes and change src youtube to embed
    iframes.forEach(function (iframe) {
      // insert each iframe into a new div at the position of the iframe
      const div = document.createElement('div');
      iframe.parentNode.insertBefore(div, iframe);

      div.classList.add('video-container');
      div.appendChild(iframe);

      iframe.classList.add('video-iframe');

      const src = iframe.src;
      let newSrc = src;
      if (src) {
        if (src.includes('youtube.com')) {
          newSrc = src.replace('youtube.com', 'youtube-nocookie.com').replace('watch?v=', 'embed/');
          iframe.src = newSrc;
        } else if (src.includes('youtu.be')) {
          newSrc = src.replace('youtu.be', 'youtube-nocookie.com/embed');
          iframe.src = newSrc;
        }
        iframe.src = newSrc;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.getElementsByClassName('tab');
    const tabNavs = document.getElementsByClassName('tab-nav');

    for (let i = 0; i < tabNavs.length; i++) {
      tabNavs[i].addEventListener('click', function () {
        openTab('tab-' + (i + 1));
      });
    }
    tabs[0].style.display = 'block';
    tabNavs[0].classList.add('active');
  });

  function openTab(tab) {
    const allTabs = document.getElementsByClassName('tab');
    const allNavs = document.getElementsByClassName('tab-nav');
    for (let i = 0; i < allTabs.length; i++) {
      allTabs[i].style.display = 'none';
      allNavs[i].classList.remove('active');
    }
    document.getElementById(tab).style.display = 'block';
    document.getElementById('tab-nav-' + tab.split('-')[1]).classList.add('active');
  }

  } catch(e) { console.error(e); }
})();
})();
